/* eslint-disable camelcase */

// Collection of URL paths to backend resources

export default {
    p2pTripAdministration: {
        namespace: 'p2p-trip-administration-b4f',
        vehicles: 'retrofitting/vehicles'
    },

    operations: {
        namespace: 'operations',

        fleets: {
            list: 'filter/parameters/fleets'
        },

        fleet: {
            jiraTickets: 'jiraTickets/settings',
            realtime: 'realtime/cardata?idtoken={0}&fleetId={1}', // for WebSocket
            cbsMessages: 'servicemessages/{0}',
            cardata: 'cardata/{0}'
        },

        vehicleHealthRecords: {
            jiraTickets: 'healthRecords/tickets'
        },

        vehicles: {
            vinLicensePlates: 'licensePlates',
            info: 'vinInfo'
        },

        logAnalyzer: {
            datasources: 'vehiclelogs/datasources/{0}?from={1}&to={2}',
            data: 'vehiclelogs/{0}/{1}?from={2}&to={3}',
            realtime: 'realtime/logFetcher' // for WebSocket
        },

        jiraTickets: {
            meta: 'jiraTickets/create/meta/{0}',
            tasks: 'jiraTickets/create/tasks',
            save: 'jiraTickets/create/{0}',
            selectValues: 'jiraTickets/selectValues/{0}',
            assignableUsers: 'jiraTickets/osa/assignables/{0}',
            update: 'jiraTickets/update/{0}/fleet/{1}',
            ticketsUserGroup: 'jiraTickets/fleet/tickets?additionalFields=description',
            updateTransition: 'jiraTickets/update/{0}/status/transition',
            ticketsAssignedUser: 'jiraTickets',
            addComment: 'jiraTickets/create/{0}/comment',
            close: 'jiraTickets/update/cancel', // payload {vin, fleet, problemId}
            addAttachments: 'jiraTickets/create/{0}/image',
            getAttachments: 'jiraTickets/attachments/{0}',
            getAssets: 'jiraTickets/create/assets/{0}',
            getJiraAttachment: 'jiraTickets/create/assets{0}?mimeType={1}'
        }
    },

    alertNotifications: {
        namespace: 'odm-notification-alert-service',
        subscription: '/subscription/{0}'
    },

    geoQuery: {
        namespace: 'odm-geo-query-service',
        businessZones: 'business-area/zones',
        parkStatisticsZones: 'parking-statistic-area/zones'
    },

    mapUpdateNotification: {
        namespace: 'odm-geo-mapupdate-notification-service',
        noParkingZones: 'no-parking-area/zones/{0}'
    },

    masterData: {
        namespace: 'odm-analytics-masterdata-service',

        filterParameters: 'masterdata/filterparameters?from={0}&to={1}'
    },

    adminMessages: {
        namespace: 'odm-tool-admin-message-service',

        all: '/admin/messages/all',
        active: '/admin/messages/active'
    },

    reporting: {
        namespace: 'reporting',

        incidents: {
            incidents: 'incidents?from={0}&to={1}',
            createOrUpdateIncident: 'incidents',
            deleteIncident: 'incidents/{0}'
        }
    },

    statelessVehicleDiagnosis: {
        namespace: 'odm-vehicle-diagnosis-service',

        events: '{0}?vin={1}&from={2}&to={3}'
    },

    vehicleDiagnosis: {
        namespace: 'vehicleDiagnosis',

        vehicleHealthRecords: {
            timelineEvents: 'healthRecords/timelineEvents'
        }
    },

    rideHailingZones: {
        namespace: 'ridehailingzones',
        byFleet: '{0}'
    },

    p2p: {
        namespace: 'p2p',
        trips: {
            getForVin: 'trips?vin={0}', // GET - DEPRECATED X.60+
            create: 'trips/{0}', // POST (0 = VIN17)
            customAction: 'trips/{0}:{1}', // POST (0 = id, 1 = name of action),
            getForFilter: 'trips', // POST,
            answerChangeRequest: 'trips/{0}/changerequest:{1}'
        },
        users: {
            getUserForId: 'users/{0}', // GET (0 = UserId)
            getUsersForVin: 'users?vin={0}' // GET (0 = VIN17)
        },
        vehicles: {
            getVehiclesForUserId: 'vehicles?userId={0}', // GET,
            getVinsForUserId: 'vehicles?userId={0}' // GET - DEPRECATED X.60+
        },
        tests: {
            getTestResultForVin: 'tests/{0}', // GET (0 = VIN17)
            requestAction: 'tests/{0}:{1}' // POST (0 = VIN17, 1 = name of action)
        }
    },

    operator: {
        namespace: 'vehicle-display',
        vehicleDisplay: {
            displayedData: 'rules/{0}',
            images: 'images/{0}/{1}',
            languages: 'languages/{0}'
        }
    },

    onSiteAgent: {
        namespace: 'odm-on-site-agent-service',
        agents: {
            create: 'agents',
            getForFleetId: 'agents/{0}',
            update: 'agents/{0}',
            delete: 'agents/{0}/{1}'
        },
        location: {
            update: 'agents/location',
            realtime: 'realtime/odm-on-site-agent-service/agentupdates?idtoken={0}&fleetId={1}'
        }
    },

    iam: {
        namespace: 'odm-user-iam-service',

        auth: {
            userByUuid: 'users-v2?uuid={0}',
            permissions: 'permissions/current-user'
        },
        admin: {
            user: {
                searchOrUpdate: 'users-v2/details/{0}',
                merged: 'users-v2/details/{0}?merged=true',
                fetch: 'users-v2'
            },
            group: {
                searchOrUpdate: 'groups-v2/details/{0}',
                fetch: 'groups-v2'
            },
            permissions: 'permissions',
            permissionSettings: 'permission-settings'
        }
    },

    iamnext: {
        namespace: 'odm-user-iamnext-service',
        userPermissions: 'permissions/my',
        realtime: 'realtime/odm-user-iamnext-service/permissionupdates?idtoken={0}'
    },

    trips: {
        namespace: 'rh-trip-service',

        byFleet: 'trips?fleetId={0}',
        changeState: 'trips/{0}/stateChange?newTripState={1}',
        cancel: 'trips/{0}/cancel',
        assign: 'trips/{0}/vehicle?vin={1}&driverId={2}',
        saveComment: 'trips/{0}/comment',
        history: 'rh-trip-administration-b4f/triphistory?fleetId={0}&from={1}&to={2}',

        realtime: 'rh-trip-administration-b4f/trips/live?idtoken={0}&fleetId={1}'
    },

    fleetAdministration: {
        namespace: 'odm-fleet-administration-b4f',

        providers: 'fleetAdministration/providers',

        all: 'fleetAdministration/fleets',
        create: 'fleetAdministration/fleets/',
        update: 'fleetAdministration/fleets/{0}',
        delete: 'fleetAdministration/fleets/{0}'
    },

    fleets: {
        namespace: 'odm-fleet-administration-b4f',

        getFleets: 'fleetFilter/fleets'
    },

    tasks: {
        namespace: 'odm-tool-task-service',
        realtime: 'realtime/odm-tool-task-service/taskupdates?idtoken={0}&fleetId={1}',
        getTasks: 'tasks?fleetId={0}&filterType={1}',
        saveTask: 'tasks',
        updateTask: 'tasks/{0}',
        addAttachments: 'tasks/{0}/attachments',
        downloadAttachment: 'tasks/{0}/attachments/{1}',
        addComment: 'tasks/{0}/comments',
        getAssets: 'tasks/{0}/assets'
    },

    drivers: {
        namespace: 'rh-driver-service',
        realtime: 'realtime/rh-driver-service/driverdata?idtoken={0}&fleetId={1}',
        relocation: {
            cancel: 'relocation/{0}/cancel',
            realtime: 'realtime/rh-driver-service/relocationdata?idtoken={0}&fleetId={1}'
        },
        assignment: {
            removeVehicle: 'assignment/{0}/removeVehicle',
            changeZone: 'assignment/{0}/changeZone?zoneId={1}'
        },
        utilization: {
            upload: 'utilization/{0}',
            download: 'utilization/{0}?referenceDate={1}',
            data: 'utilization/{0}?startDate={1}&endDate={2}',
            change: 'utilization/{0}?referenceDate={1}'
        }
    },

    fav: {
        namespace: 'rh-fav-state-service',
        realtime: 'realtime/rh-fav-state-service/favstate?idtoken={0}&fleetId={1}',
        state: 'fav/state',
        reset: 'fav/state:reset',
        fad: {
            realtime: 'realtime/rh-fav-state-service/fad-function-state?idtoken={0}&fleetId={1}'
        }
    },

    fleetManagement: {
        namespace: 'odm-vehicle-stateless-data-service-b4f',
        realtime: 'realtime/odm-vehicle-stateless-data-b4f/vehicleupdates?idtoken={0}&fleetId={1}'
    },

    tripUpdateNotification: {
        namespace: 'rh-trip-update-notification-service',
        trigger: {
            getTriggers: 'notificationtriggers?fleetId={0}',
            updateTrigger: 'notificationtriggers/{0}?fleetId={1}'
        },
        templates: 'templates?fleetId={0}&notificationTrigger={1}&channel={2}',
        getLanguages: 'languages?fleetId={0}',
        postLanguages: 'languages/{0}',
        deleteLanguage: 'languages/{0}/{1}'
    },

    vehicleTag: {
        namespace: 'odm-vehicle-tag-b4f',
        tag: {
            all: 'tags',
            create: 'tags',
            update: 'tags/{0}',
            delete: 'tags/{0}',
            byFleet: 'tags?fleetId={0}'
        },
        tagAssignments: {
            all: 'tagassignments',
            byFleet: 'tagassignments?fleetId={0}'
        },
        operator: {
            all: 'currentuser/allowedoperators'
        }
    },

    vehicleAlert: {
        namespace: 'odm-vehicle-stateless-alert-service',
        alertSettings: {
            byFleets: '/alertSettings/byFleets',
            getForTypeAndFleetId: '/alertSettings/{0}/{1}',
            save: '/alertSettings/{0}',
            delete: '/alertSettings/{0}',
            byCriticality: '/alertSettings/byCriticality/{0}'
        }
    },

    rhMember: {
        namespace: 'rh-member-service',
        members: {
            byUsername: 'members/{0}'
        }
    }
};
